import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { SidenavService } from '../../services/sidenav.service';
import { NotificationsSidenavService } from '../../services/notifications-sidenav.service';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { environment } from '../../../environments/environment';
import { retryWhen, delay, map, distinctUntilChanged, mergeMap } from 'rxjs/operators';
import { SensorEventsService } from '../../services/sensor-events.service';
import { LoaderService } from '../../services/loader.service';
import { UserService } from '../../services/user.service';
import { EnvironmentInstanceService } from '../../environment-instance.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  public loginUrl: boolean;

  public sensorNotifications: any;

  public loading: boolean;

  public user$: Observable<any>;

  private roles: any[];

  constructor(
    private envService: EnvironmentInstanceService,
    private translate: TranslateService,
    private sidenavService: SidenavService,
    private notificationsSidenavService: NotificationsSidenavService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router) {
    if (this.router.url.includes('/login')) this.loginUrl = true;
  }

  ngOnInit() {
    this.roles = this.envService.roles
    this.user$ = this.authService.currentUser
      .pipe(
        map(res => {
          return (res !== null && res['id'] !== null) ? res['id'] : of(null)
        }),
        mergeMap(id => {
          return id !== null ? this.userService.getById(id) : of(null)
        }),
        map(res => res['data']),
        map(res => {
          let roleViewValue = this.roles.filter(role => {
            if (role['value'] === res['attributes']['role']) {
              return role['viewValue']
            }
          })

          return {
            role: roleViewValue[0]['viewValue'],
            username: res['attributes']['username']
          }
        })
      )
  }

  toggleSidenav() {
    this.sidenavService.toggle();
  }

  logOut() {
    this.authService.logout();
  }

  notifications() {
    this.notificationsSidenavService.toggle();
  }

  ngOnDestroy() {
  }

}
